import {compute, create} from "@targoninc/jess";
import {search, searchResults, searchModalOpen, currentPage, searchSelectedIndex} from "../lib/state.ts";

export function searchModal() {
    const onOverlayClick = (e: MouseEvent) => {
        if (e.target === e.currentTarget) {
            searchModalOpen.value = false;
        }
    };

    const onInput = (e: any) => {
        search.value = e.target.value;
    };

    const onClose = () => {
        searchModalOpen.value = false;
    };

    const onKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            searchModalOpen.value = false;
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            if (searchSelectedIndex.value < searchResults.value.length - 1) {
                searchSelectedIndex.value++;
            }
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (searchSelectedIndex.value > 0) {
                searchSelectedIndex.value--;
            }
        } else if (e.key === "Enter") {
            const selectedResult = searchResults.value[searchSelectedIndex.value];
            if (selectedResult) {
                currentPage.value = selectedResult.page.filename;
                searchModalOpen.value = false;
                search.value = "";
            }
        }
    };

    searchModalOpen.subscribe((open) => {
        if (open) {
            setTimeout(() => {
                const input = document.querySelector(".search-modal-input") as HTMLInputElement;
                if (input) {
                    input.focus();
                    input.value = search.value;
                }
            }, 0);
        }
    });

    searchSelectedIndex.subscribe(() => {
        setTimeout(() => {
            const selected = document.querySelector(".search-modal-result-item.selected");
            if (selected) {
                selected.scrollIntoView({ block: "nearest" });
            }
        }, 0);
    });

    return compute((open) => {
        return create("div")
            .classes("search-modal-overlay", open ? "show" : "")
            .onclick(onOverlayClick)
            .children(
                create("div")
                    .classes("search-modal")
                    .children(
                        create("div")
                            .classes("search-modal-input-container")
                            .children(
                                create("span")
                                    .classes("material-symbols-outlined", "search-icon")
                                    .text("search")
                                    .build(),
                                create("input")
                                    .classes("search-modal-input")
                                    .attributes("placeholder", "Search documentation...", "type", "text")
                                    .oninput(onInput)
                                    .onkeydown(onKeyDown)
                                    .build(),
                                create("button")
                                    .classes("search-modal-close-button")
                                    .onclick(onClose)
                                    .children(
                                        create("span")
                                            .classes("material-symbols-outlined")
                                            .text("close")
                                            .build()
                                    ).build()
                            ).build(),
                        compute((results, term) => {
                            const highlight = (text: string, t: string) => {
                                if (t.length === 0) return [create("span").text(text).build()];
                                const lowerText = text.toLowerCase();
                                const lowerTerm = t.toLowerCase();
                                const children: any[] = [];
                                let lastIndex = 0;
                                let index = lowerText.indexOf(lowerTerm);
                                while (index !== -1) {
                                    if (index > lastIndex) {
                                        children.push(create("span").text(text.substring(lastIndex, index)).build());
                                    }
                                    children.push(
                                        create("mark")
                                            .classes("search-highlight")
                                            .text(text.substring(index, index + t.length))
                                            .build()
                                    );
                                    lastIndex = index + t.length;
                                    index = lowerText.indexOf(lowerTerm, lastIndex);
                                }
                                if (lastIndex < text.length) {
                                    children.push(create("span").text(text.substring(lastIndex)).build());
                                }
                                return children;
                            };

                            return create("div")
                                .classes("search-modal-results")
                                .children(
                                    ...results.map((res, index) => {
                                        return compute((selectedIndex) => {
                                            return create("div")
                                                .classes("search-modal-result-item", selectedIndex === index ? "selected" : "")
                                                .onclick(() => {
                                                    currentPage.value = res.page.filename;
                                                    searchModalOpen.value = false;
                                                    search.value = "";
                                                })
                                                .children(
                                                    create("div")
                                                        .classes("search-modal-result-title")
                                                        .children(...highlight(res.page.title, term))
                                                        .build(),
                                                    create("div")
                                                        .classes("search-modal-result-excerpt")
                                                        .children(...highlight(res.excerpt, term))
                                                        .build()
                                                ).build();
                                        }, searchSelectedIndex);
                                    })
                                ).build();
                        }, searchResults, search)
                    ).build()
            ).build();
    }, searchModalOpen);
}
